export default {
      id: "menu__shipment-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg#menu__shipment",
      toString: function () {
        return this.url;
      }
    }